import { Row, RenderConfig, TextInput, NumberInput, CheckboxInput, Column, EMPTY_ARRAY } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	EMAIL: 'email',
	ZUPEE_USER_ID: 'uid',
	PHONE_NUMBER: 'phone',
	USER_SEGMENT: 'userSegment',
	DELETE: 'deleteSegment'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.EMAIL]: 'Email',
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: 'Zupee User Id',
	[FORM_FIELD_KEYS.PHONE_NUMBER]: 'Phone Number',
	[FORM_FIELD_KEYS.USER_SEGMENT]: 'Segment Names',
	[FORM_FIELD_KEYS.DELETE]: 'To Be Deleted'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.EMAIL]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.EMAIL)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.EMAIL])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ZUPEE_USER_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ZUPEE_USER_ID])
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.PHONE_NUMBER]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.PHONE_NUMBER)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.PHONE_NUMBER])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.USER_SEGMENT]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.USER_SEGMENT)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.USER_SEGMENT])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			required: true
		}),
	[FORM_FIELD_KEYS.DELETE]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DELETE)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.DELETE])
		.setRenderer(CheckboxInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			checked: false
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.ZUPEE_USER_ID)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.PHONE_NUMBER)]), new Column([new Row(FORM_FIELD_KEYS.EMAIL)])]),
	new Row(FORM_FIELD_KEYS.USER_SEGMENT),
	new Row(FORM_FIELD_KEYS.DELETE)
];
